import type { UpdateNotificationReadStatus200BasicInfoAllOf } from './updateNotificationReadStatus200BasicInfoAllOf';
import type { UpdateNotificationReadStatus200BasicInfoAllOfTwo } from './updateNotificationReadStatus200BasicInfoAllOfTwo';

export type UpdateNotificationReadStatus200BasicInfo = UpdateNotificationReadStatus200BasicInfoAllOf & UpdateNotificationReadStatus200BasicInfoAllOfTwo;
